import{gql as o}from"@apollo/client";const s=o`
  mutation resetPassword($code: String!, $newPassword: String!) {
    resetPassword: forgotPasswordUpdate(code: $code, newPassword: $newPassword)
  }
`;export{s as RESET_PASSWORD_MUTATION};
//# sourceMappingURL=useResetPassword.graphql.js.map
